export default __webpack_public_path__ + "736ac439765de61489c622815c0b8313.svg";